import { userConstants } from './../constants/user.constants';

let user = sessionStorage.getItem('user');
const initialState = user ? { user, isLoading: false } : {};

export function Fundcode(state = initialState, action) {
  
  console.log("inside fundcode", action)
  switch (action.type) {
    case userConstants.FUNDCODE_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.FUNDCODE_SUCCESS:
      const {res} = action
        console.log("Action", action)
      return {
        res,
        isLoading : false
      };
    case userConstants.FUNDCODE_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}